// Toont bij een taak wat de actie is, waarom, en waar de taak vandaan komt.
// Taken zonder die velden krijgen een knop om ze met AI aan te vullen.
import { useState } from "react";
import { C, Chip, schoneNotitie } from "./gedeeld";
import { mistContext, verduidelijkTaken } from "./taakVerduidelijking";

export default function TaakInfo({ taak, naAanvullen, openKlant }) {
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState("");
  const notitie = schoneNotitie(taak.notes);
  const heeft = (taak.actie && String(taak.actie).trim()) || (taak.waarom && String(taak.waarom).trim());

  async function vulAan() {
    setBezig(true); setFout("");
    try { await verduidelijkTaken([taak], 1); if (naAanvullen) await naAanvullen(); }
    catch (e) { setFout(e.message || "Mislukt"); }
    setBezig(false);
  }

  return (
    <div style={{ marginTop: 6 }}>
      {heeft ? (
        <div style={{ display: "grid", gap: 3, fontSize: 12, lineHeight: 1.55 }}>
          {taak.actie && <p style={{ margin: 0 }}><span style={{ color: C.blue, fontWeight: 700 }}>Actie </span>{taak.actie}</p>}
          {taak.waarom && <p style={{ margin: 0, color: C.muted }}><span style={{ color: C.yellow, fontWeight: 700 }}>Waarom </span>{taak.waarom}</p>}
        </div>
      ) : (
        taak.status !== "done" && mistContext(taak) && (
          <p style={{ margin: 0, fontSize: 11, color: C.dim }}>
            Nog niet duidelijk wat er moet gebeuren en waarom.{" "}
            <button className="btn bg" style={{ padding: "2px 8px", fontSize: 11 }} disabled={bezig} onClick={vulAan}>{bezig ? "Bezig..." : "Vul aan met AI"}</button>
          </p>
        )
      )}
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginTop: 5 }}>
        {taak.bron && <Chip tekst={taak.bron} />}
        {taak.lead_id != null && openKlant && <button className="btn bg" style={{ padding: "2px 8px", fontSize: 11 }} onClick={() => openKlant(taak.lead_id)}>Klantdossier</button>}
      </div>
      {notitie && <p style={{ fontSize: 12, color: C.muted, margin: "5px 0 0", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>{notitie}</p>}
      {fout && <p style={{ fontSize: 11, color: C.red, margin: "4px 0 0" }}>{fout}</p>}
    </div>
  );
}
